<template>
  <base-material-card
    icon="mdi-domain"
    title="Organizações ClinicOne"
    color="primary"
    :loading="loading"
    class="flex-grow-1 d-flex flex-column"
  >
    <v-row
      dense
      class="mb-2"
    >
      <v-col
        cols="12"
        sm="7"
      >
        <v-text-field
          v-model="search"
          label="Buscar organização"
          placeholder="Nome da organização..."
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          clearable
          hide-details
          @keyup.enter="reload(true)"
          @click:clear="onSearchClear"
        />
      </v-col>
      <v-col
        cols="8"
        sm="3"
      >
        <v-select
          v-model="enabledFilter"
          :items="enabledOptions"
          label="Status"
          outlined
          dense
          hide-details
          @change="reload(true)"
        />
      </v-col>
      <v-col
        cols="4"
        sm="2"
        class="d-flex align-center"
      >
        <v-btn
          color="primary"
          small
          block
          @click="reload(true)"
        >
          <v-icon small>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
      item-key="id"
      class="elevation-0 flex-grow-1 row-pointer"
      single-select
      dense
      @click:row="onRowClick"
    >
      <template #item.habilitado="{ item }">
        <v-chip
          :color="item.habilitado ? 'success' : 'grey'"
          x-small
          dark
        >
          {{ item.habilitado ? 'Ativa' : 'Desativada' }}
        </v-chip>
      </template>
    </v-data-table>
  </base-material-card>
</template>

<script>
  import { $k } from '@/lib/kraken'

  const ENABLED_OPTIONS = [
    { text: 'Todos', value: null },
    { text: 'Ativos', value: true },
    { text: 'Desativados', value: false },
  ]

  export default {
    name: 'OrganizationsList',

    props: {
      selectedId: { type: [Number, String], default: null },
    },

    data: () => ({
      search: '',
      enabledFilter: null,
      items: [],
      total: 0,
      options: { page: 1, itemsPerPage: 10 },
      loading: false,
      headers: [
        { text: 'ID', value: 'id', width: 70 },
        { text: 'Nome', value: 'nome' },
        { text: 'Status', value: 'habilitado', width: 110 },
        { text: 'Membros', value: 'membros_ativos', width: 90, align: 'end' },
      ],
      enabledOptions: ENABLED_OPTIONS,
    }),

    watch: {
      options: {
        deep: true,
        handler () { this.reload() },
      },
    },

    mounted () {
      this.reload(true)
    },

    methods: {
      onSearchClear () {
        this.search = ''
        this.reload(true)
      },
      onRowClick (org) {
        this.$emit('select', org)
      },
      async reload (resetPage = false) {
        if (resetPage) this.options = { ...this.options, page: 1 }
        this.loading = true
        try {
          const skip = (this.options.page - 1) * this.options.itemsPerPage
          const payload = { skip, limit: this.options.itemsPerPage }
          if (this.search) payload.q = this.search
          if (this.enabledFilter !== null) payload.habilitado = this.enabledFilter
          const res = await $k.manage.clinic_one.organizations.get(payload)
          this.items = res.results || []
          this.total = res.total || 0
        } catch (err) {
          console.error('[organizations.get]', err)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
.row-pointer >>> tbody tr {
  cursor: pointer;
}
</style>
